import { TenantCapabilitiesResponseSchema } from '../../schemas/tenant-features.schemas.js';
/** REST contract for `insight-api/src/routes/tenant-features.routes.ts`. */
export const tenantFeaturesContract = {
    getCapabilities: {
        method: 'GET',
        path: '/tenant/features/capabilities',
        response: TenantCapabilitiesResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get tenant capabilities',
    },
};
//# sourceMappingURL=tenant-features.contract.js.map